import { Theme } from '@mui/material';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const CcfAcdLeftNavAccordionStyles = (theme: Theme) => {
  const simStyles = {
    accordionContainer: {
      boxShadow: 'none !important',
      margin: '0px !important',
      minHeight: '55px !important',
      '&$expanded': {
        margin: '0',
      },
    },

    accordionHeaderExpand: {
      flexDirection: 'column',
      paddingLeft: '10px',
      padding: '0px',
      display: 'flex',
      margin: '0px !important',
    },

    accordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      margin: '0px !important',
      minHeight: '55px !important',
      '.MuiAccordionSummary-content': {
        margin: '0px !important',
        '&$expanded': {
          margin: '0px !important',
        },
      },
      '.MuiAccordionSummary-expandIconWrapper': {
        position: 'absolute',
        marginRight: '15px',
        right: '0px',
        '&$expanded': {
          position: 'absolute',
          marginRight: '15px',
          right: '0px',
        },
      },
      '&$expanded': {
        margin: '0px !important',
      },
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px #fdeeef`,
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      margin: '0',
      '&$expanded': {
        margin: '0',
      },
    },

    expandedIcon: {
      transform: 'rotate(180deg)',
      background: `#FFFFF 0% 0% no-repeat padding-box`,
      color: '#5B7C8C',
      width: '24px',
      height: '24px',
    },

    hideAccordion: {
      display: 'none',
    },
  };
  return simStyles;
};
export default CcfAcdLeftNavAccordionStyles;
